



















































import Vue from "vue";
import { $eventsBus } from "@/main";
import BaseSimpleSlider from "@/app/shared/components/base/BaseSimpleSlider.vue";
import BaseVideoRangeSlider from "@/app/shared/components/base/BaseVideoRangeSlider.vue";
import BaseCheckbox from "@/app/shared/components/base/BaseCheckbox.vue";
import BaseInput from "@/app/shared/components/base/BaseInput.vue";
import BaseButton from "@/app/shared/components/base/BaseButton.vue";

export default Vue.extend({
  name: "RendersController",
  components: {
    BaseSimpleSlider,
    BaseVideoRangeSlider,
    BaseCheckbox,
    BaseInput,
    BaseButton,
  },
  data: function () {
    return {
      checkedCount: 0,
      renderIdsForCheck: [],
      renderCanceled: false,
      loading: true,
      //percent: -1,
      message: "Upload...",
      checkStatusId: null,
    };
  },
  created() {
    $eventsBus.$on("exportItems", () => {
      //this.buyingStockMaterialsAndStartRender();
      this.sendToRender();
    });
  },
  computed: {
    items: function () {
      return this.$store.state.items;
    },
    percentNew: function () {
      return Math.floor(
        (this.renderItems.filter((item) => item.loaded || item.error).length /
          this.renderItems.length) *
          100
      );
    },
    renderItems: {
      // getter
      get: function () {
        /*         let tempItems = [];
        for (let index = 0; index < 15; index++) {
          tempItems.push({
            renderId: index,
            loaded: true,
            error: false,
            checked: false,
            fileName: "item" + index,
            size: "s",
            preset: "none",
          });
        } */
        return this.$store.state.renderItems;
      },
      // setter
      set: function (newValue) {
        this.$store.commit("renderItems", newValue);
      },
    },
    isSomeCheck: function () {
      return this.renderItems.length === 0
        ? false
        : !this.renderItems.every((i) => i.checked) &&
            this.renderItems.some((i) => i.checked);
    },
    isAllChecked: {
      // getter
      get: function () {
        return this.renderItems.length === 0
          ? false
          : this.renderItems.every((i) => i.checked);
      },
      // setter
      set: function (newValue) {
        if (newValue) {
          this.renderItems.forEach((item) => {
            item.checked = true;
          });
        } else {
          this.renderItems.forEach((item) => {
            item.checked = false;
          });
        }
      },
    },
    audioParameters: function () {
      return this.$store.state.audioParameters;
    },
    selectedTransitionId: {
      get: function () {
        return this.$store.state.selectedTransitionId;
      },
      set: function (id) {
        this.$store.commit("changeSelectedTransitionId", id);
      },
    },
    mixedParts: {
      get: function () {
        return this.$store.state.mixedParts;
      },
      set: function (mixedParts) {
        this.$store.commit("mixedParts", mixedParts);
      },
    },
  },
  watch: {
    renderItems: {
      deep: true,
      handler() {
        if (this.renderItems.length === 0) {
          this.$store.commit("showDownloadPanel", false);
          this.stopUpdating();
        } else {
          this.renderIdsForCheck = this.renderItems
            .filter((i) => !i.loaded)
            .map((i) => i.renderId);
          if (this.checkStatusId === null && this.renderIdsForCheck.length) {
            this.checkStatusId = setInterval(this.checkMultiStatus, 1000);
          }
        }
        this.checkedCount = this.renderItems.filter((v) => v.checked).length;
      },
    },
  },
  mounted() {},
  methods: {
    onClearDone() {
      this.renderItems = this.renderItems.filter((i) => {
        if (i.loaded) {
          this.renderIdsForCheck.splice(
            this.renderIdsForCheck.indexOf(i.renderId),
            1
          );
        }
        return !i.loaded;
      });
      $eventsBus.$emit("saveUserWorkspace");
    },
    onMultiDelete() {
      if (this.isAllChecked) {
        this.renderItems = [];
        this.stopUpdating();
        $eventsBus.$emit("saveUserWorkspace");
        return;
      }

      this.renderItems
        .map((it) => it)
        .forEach((i) => {
          if (i.checked) {
            this.renderItems.splice(this.renderItems.indexOf(i), 1);
            this.renderIdsForCheck.splice(
              this.renderIdsForCheck.indexOf(i.renderId),
              1
            );
          }
        });

      if (this.renderIdsForCheck.length === 0) {
        this.stopUpdating();
      }
      $eventsBus.$emit("saveUserWorkspace");
    },
    onStopRender() {
      this.renderItems = this.renderItems.filter((i) => i.loaded);
      this.stopUpdating();
    },
    stopUpdating() {
      this.loading = false;
      //this.percent = -1;
      this.message = "Upload...";
      clearInterval(this.checkStatusId);
      this.checkStatusId = null;
      this.renderIdsForCheck = [];
    },
    onCheckItem(item) {
      this.$forceUpdate();
    },
    onClickDownloadIcon(item) {
      if (item.loaded && !item.error) {
        //watch
        //$eventsBus.$emit("showRenderItemPreview", item);
        //this.$store.commit("showRendersPreviewWindow", true);
        this.downloadFile(item.path, item.outputName);
      }
    },
    onClickDeleteIcon(item) {
      this.renderIdsForCheck.splice(
        this.renderIdsForCheck.indexOf(item.renderId),
        1
      );
      this.renderItems.splice(this.renderItems.indexOf(item), 1);
      if (this.renderIdsForCheck.length === 0) {
        this.stopUpdating();
      }
      $eventsBus.$emit("saveUserWorkspace");
    },
    /*     onClickItemIcon(item, onlyPreview?) {
      if (item.loaded && !item.error) {
        //watch
        //$eventsBus.$emit("showRenderItemPreview", item);
        //this.$store.commit("showRendersPreviewWindow", true);
        this.downloadFile(item.path, item.outputName);
      } else {
        //delete
        if (onlyPreview) {
          return;
        }
        this.renderIdsForCheck.splice(
          this.renderIdsForCheck.indexOf(item.renderId),
          1
        );
        this.renderItems.splice(this.renderItems.indexOf(item), 1);
        if (this.renderIdsForCheck.length === 0) {
          this.stopUpdating();
        }
        $eventsBus.$emit("saveUserWorkspace");
      }
    }, */
    onClickDownload() {
      this.downloadResult();
      let countToDownload = this.renderItems.filter(
        (i) => i.checked && i.loaded && !i.error
      ).length;
    },
    sendToRender() {
      let cutsByFileIdMap = new Map();
      this.mixedParts.forEach((part, index) => {
        let cutsByFileId = cutsByFileIdMap.get(part.parentItemInfo.fileId);
        if (cutsByFileId) {
          cutsByFileId.push({
            index: index + 1,
            startFrame: Math.round(part.startTime * part.parentItemInfo.fps),
            finishFrame: Math.round(part.finishTime * part.parentItemInfo.fps),
            startSec: part.startTime,
            finishSec: part.finishTime,
            transitions: this.selectedTransitionId,
          });
        } else {
          cutsByFileIdMap.set(part.parentItemInfo.fileId, [
            {
              index: index + 1,
              startFrame: Math.round(part.startTime * part.parentItemInfo.fps),
              finishFrame: Math.round(
                part.finishTime * part.parentItemInfo.fps
              ),
              startSec: part.startTime,
              finishSec: part.finishTime,
              transitions: this.selectedTransitionId,
            },
          ]);
        }
      });
      let parts = [];
      cutsByFileIdMap.forEach((value, key) => {
        parts.push({ fileId: key, cuts: value });
      });
      let startMultiRender = {
        tasks: [
          {
            audio: {
              id: this.audioParameters.musicFile
                ? this.audioParameters.musicFile.id
                : 0,
              volume: this.audioParameters.musicVolume / 100,
            },
            parts: parts,
            volume: this.audioParameters.volume / 100,
            index: 1,
          },
        ],
      };
      this.startMultiRenderVideos(startMultiRender);
      //$eventsBus.$emit("itemsExported");
    },
    startMultiRenderVideos(postData) {
      this.message = "Prepare render task ...";
      this.axios
        .post("/v2.0/process/PrepareToRender", postData, {
          headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          if (!this.renderCanceled) {
            console.log(response.data);
            this.message = "Progress...";
            if (response.data.success) {
              response.data.tasks.forEach((t) => {
                this.renderItems.unshift({
                  renderId: t.renderId,
                  fileName: t.fileName,
                  checked: true,
                  loaded: false,
                  error: false,
                });
              });
              this.renderIdsForCheck = this.renderItems
                .filter((i) => !i.loaded)
                .map((i) => i.renderId);
              if (this.checkStatusId === null) {
                this.checkStatusId = setInterval(this.checkMultiStatus, 1000);
              }
            } else {
              this.message = "Server error!";
            }
            $eventsBus.$emit("saveUserWorkspace");
          }
          $eventsBus.$emit("itemsExported");
        })
        .catch((erorr) => {
          this.message = "Server error!";
          console.error(erorr);
          $eventsBus.$emit("itemsExported");
        });
    },
    checkMultiStatus() {
      let renderIds = this.renderIdsForCheck;

      if (renderIds.length === 0) {
        this.stopUpdating();
      }

      this.axios
        .post(
          "v2.0/process/checkStatus",
          {
            renderIds: renderIds,
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          this.successCheckMultiStatus(response.data);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    successCheckMultiStatus(data) {
      if (this.renderCanceled) {
        this.stopUpdating();
        return;
      }
      if (data.status && data.status.toLowerCase() === "done") {
        this.message = "Render complete";
        //this.percent = 100;
        setTimeout(() => {
          this.stopUpdating();
        }, 500);

        let errorIds = [];
        data.tasks.forEach((task) => {
          let renderItem = this.renderItems.find((i) => i.renderId === task.id);

          if (renderItem && !renderItem.loaded) {
            renderItem.path = task.path;
            renderItem.outputName = task.fileName;
            renderItem.loaded = true;
            renderItem.error = task.task.toLowerCase() === "error";
            if (renderItem.error) {
              errorIds.push(task.id);
            }
          }
        });
        if (errorIds.length !== 0) {
        }
        $eventsBus.$emit("saveUserWorkspace");
      } else {
        let tasksAllCount = data.tasks.length;
        let tasksDoneCount = 0;
        let tasksErrorCount = 0;
        let errorIds = [];
        data.tasks.forEach((uploadedFile) => {
          let renderItem;
          switch (uploadedFile.status.toLowerCase()) {
            case "error":
              tasksErrorCount++;
              errorIds.push(uploadedFile.id);
              renderItem = this.renderItems.find(
                (i) => i.renderId === uploadedFile.id
              );
              if (renderItem && !renderItem.loaded) {
                renderItem.loaded = true;
                renderItem.error = true;
              }
              break;
            case "prepare":
              break;
            case "start":
              break;
            case "finish":
              tasksDoneCount++;
              renderItem = this.renderItems.find(
                (i) => i.renderId === uploadedFile.id
              );
              if (renderItem && !renderItem.loaded) {
                renderItem.path = uploadedFile.path;
                renderItem.outputName = uploadedFile.fileName;
                renderItem.loaded = true;
              }
              break;
          }
        });
        //Loger block:
        if (tasksDoneCount === 0) {
          //this.percent = 0;
          this.message = "Rendering... " + this.percentNew + "%";
        } else {
          if (tasksDoneCount !== tasksAllCount) {
            //this.percent = Math.floor((tasksDoneCount / tasksAllCount) * 100);
            let progressMsg = "Rendering... " + this.percentNew + "%";

            /*             if (tasksErrorCount != 0) {
              progressMsg += ". Errors: " + tasksErrorCount;
            } */
            this.message = progressMsg;
          } else {
            //this.percent = 100;
            let progressMsg = "Uploading..." + this.percentNew + "%";
            /*             if (tasksErrorCount != 0) {
              progressMsg += ". Errors: " + tasksErrorCount;
            } */
            this.message = progressMsg;
          }
        }
        if (tasksErrorCount === tasksAllCount) {
          this.message = "Server error!";
          this.stopUpdating();
        }
      }
    },

    //------------------------------------ DOWNLOADING

    downloadResult() {
      let downloadingItems = this.renderItems.filter(
        (i) => i.checked && i.loaded && !i.error
      );
      if (downloadingItems.length > 20) {
        this.downloadArchive(downloadingItems.map((i) => i.renderId));
      } else {
        downloadingItems.forEach((item) => {
          this.downloadFile(item.path, item.outputName);
        });
      }
    },
    downloadArchive(renderIds) {
      this.axios
        .post(
          "/utils/getArchive",
          {
            renderIds: renderIds,
            sessionId: this.$store.state.userInfo.sessionId,
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          this.downloadFile(response.data.archive);
        })
        .catch((erorr) => {
          this.message = "Server error!";
          console.error(erorr);
        });
    },
    downloadFile(path, fileName?) {
      if (path === "") {
        return;
      }
      let downloadHref = this.$baseURL + path;
      let link = document.createElement("a");
      link.setAttribute("target", "_blank");
      document.body.appendChild(link); // Firefox requires the link to be in the body
      link.download = fileName ? fileName : path.split("/").pop();
      link.href = downloadHref;
      link.click();
      document.body.removeChild(link); // remove the link when done
    },
  },
});
